import { FormattedMessage } from 'react-intl';

import { DefaultUserMenu, EulaConsent } from '@rio-cloud/rio-user-menu-component';
// TODO add this back in once its compatible with uikit v3
// import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import IframeResizer from '@rio-cloud/iframe-resizer';

import { config } from '../../config';
import { getTrackingAttributes } from '../../configuration/setup/googleAnalytics';

const AppHeader = () => {
    const environment = import.meta.env.PROD ? 'production' : 'local';
    const isLocalhost = import.meta.env.DEV;

    // const notifications = <RioNotifications />;
    const userMenuItem = <DefaultUserMenu environment={environment} />;

    return (
        <>
            <ApplicationHeader
                label={<FormattedMessage id={'intl-msg:moduleName'} defaultMessage={'App Login Administration'} />}
                appNavigator={
                    <IframeResizer
                        className={'iFrameResizer'}
                        src={config.backend.MENU_SERVICE}
                        title={'appNavigator'}
                    />
                }
                homeRoute={
                    <a
                        href={isLocalhost ? window.location.origin : config.homeRoute || ''}
                        {...getTrackingAttributes({
                            trigger: 'click',
                            category: 'link autoTracking',
                            action: 'link click',
                            label: 'app-header.home-route',
                            value: '',
                        })}
                    />
                }
                navItems={[]}
                // actionBarItems={[notifications, userMenuItem]}
                actionBarItems={[userMenuItem]}
            />
            <EulaConsent environment={environment} />
        </>
    );
};

export default AppHeader;
